var map = {
	"./agustín-do-rego.png": 6064,
	"./aleksandr-starodub.png": 5493,
	"./alexander-pokofiev.png": 8279,
	"./alexander-prokofiev.png": 3711,
	"./alisher-nurlybaev.png": 3336,
	"./aniel-essien.png": 9632,
	"./anna-starovoytova.png": 4935,
	"./arina-korobeinikova.png": 3786,
	"./azamat-akmatov.png": 8413,
	"./bohdan-borysov.png": 866,
	"./default.png": 2024,
	"./diana-maduan.png": 7623,
	"./dmitrii-sidorov.png": 6442,
	"./dmitry-kogut.png": 8619,
	"./ebuka-okafor.png": 6492,
	"./eduard-poghosyan.png": 9351,
	"./egor-reutov.png": 1108,
	"./evgenii-vorontsov.png": 7201,
	"./grigory-sargsyan.png": 8389,
	"./helen-li.png": 7553,
	"./igor-teplinsky.png": 464,
	"./ilia-malyshev.png": 7034,
	"./kamilla-akhsanova.png": 9921,
	"./krokhmal-oleksandr.png": 6488,
	"./lusta-vlad.png": 1252,
	"./m.c.-ikechi.png": 6997,
	"./maira-barat.png": 4368,
	"./marina-mironova.png": 8145,
	"./mike-tomlin.png": 7821,
	"./mikhail-chutskov.png": 7644,
	"./mikhaïl-molchanov.png": 4074,
	"./nikita-pashkov.png": 6422,
	"./oleksandr-krokhmal.png": 9168,
	"./parasat-talap.png": 7882,
	"./pavel-sudakov.png": 9701,
	"./rahim-aimaganbetov.png": 9471,
	"./romain-cajina.png": 8764,
	"./sergey-romanov.png": 2383,
	"./shestakov-vitaliy.png": 1416,
	"./sofia-peremotina.png": 1636,
	"./tanny-boiarinova.png": 2518,
	"./vasiliy-lobarev.png": 3040,
	"./victor-dmitrishen.png": 952,
	"./vitaliy-shestakov.png": 7680,
	"./vlad-lusta.png": 3776,
	"./vladimir-chizganov.png": 2971,
	"./vladyslav-mykolaienko.png": 3127,
	"./vorontsov-evgenii.png": 4833,
	"./yedil-akhmetkarimov.png": 2404,
	"./yegor-sibirskiy.png": 6677,
	"./yerassyl-murat.png": 8207,
	"./yerassyl-ospanov.png": 8168,
	"./yeskendir-sarinov.png": 9153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8012;